import { useContext } from 'react';
import { AuthContext } from 'shared/components';

export const useAuthContext = () => useContext(AuthContext);
